import {required, requiredIf} from 'vuelidate/lib/validators'

const requiredIfCS = requiredIf((vm) => {
  let list = [1,16];
  return !!list.includes(vm.deliveryManner)
});

const requiredIfInduced = requiredIf((vm) => {
  return vm.isInduced === true
});

const requiredIfAnyDeath = requiredIf((vm) => {
  return vm.motherCondition === 3
})

const requiredDeliveryIndication = requiredIf((vm) => {
  let csList = [1];
  let forcepsList = [5,6];
  let vacuumList = [];
  let list = csList.concat(forcepsList, vacuumList);
  return !!list.includes(vm.deliveryManner)
});

const requiredIfExactAOG = requiredIf((vm) => {
  return vm.deliveryAOGType === 1;
});

export default {
  deliveryDate: {
    required
  },
  deliveryAOG: {
    required
  },
  deliveryWeeks: {
    requiredIf: requiredIfExactAOG
  },
  deliveryDays: {
    requiredIf: requiredIfExactAOG
  },
  deliveryManner: {
    required
  },
  // Complicated Pregnancy
  isInduced: {
    required
  },
  inducedIndication: {
    requiredIf: requiredIfInduced
  },
  inducedMethod: {
    requiredIf: requiredIfInduced
  },
  inducedComplication: {
    requiredIf: requiredIfInduced
  },
  deathReviewed: {
    requiredIf: requiredIfAnyDeath
  },
  primaryRepeat: {
    requiredIf: requiredIfCS
  },
  incision: {
    requiredIf: requiredIfCS
  },
  CSBilateralSalpingectomy: {
    requiredIf: requiredIfCS
  },
  CSBTL: {
    requiredIf: requiredIfCS
  },
  deliveryIndication: {
    required: requiredDeliveryIndication
  }
}
